var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "signup" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("auth.createNewAccount")))]),
    _c(
      "form",
      { attrs: { method: "post", action: "/#/auth/signup", name: "signup" } },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              attrs: { type: "text", id: "email", required: "required" },
            }),
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "email" } },
              [_vm._v(_vm._s(_vm.$t("auth.email")))]
            ),
            _c("i", { staticClass: "bar" }),
          ]),
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              attrs: { type: "password", id: "password", required: "required" },
            }),
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "password" } },
              [_vm._v(_vm._s(_vm.$t("auth.password")))]
            ),
            _c("i", { staticClass: "bar" }),
          ]),
        ]),
        _c(
          "vuestic-checkbox",
          {
            attrs: { name: "agree-to-terms" },
            model: {
              value: _vm.agreedToTerms,
              callback: function ($$v) {
                _vm.agreedToTerms = $$v
              },
              expression: "agreedToTerms",
            },
          },
          [
            _c("template", { slot: "label" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("auth.agree")) + "\n        "
              ),
              _c("a", { staticClass: "link", attrs: { href: "#" } }, [
                _vm._v(_vm._s(_vm.$t("auth.termsOfUse"))),
              ]),
            ]),
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass:
              "d-flex align--center justify--space-between down-container",
          },
          [
            _c(
              "button",
              { staticClass: "btn btn-primary", attrs: { type: "submit" } },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("auth.signUp")) + "\n      "
                ),
              ]
            ),
            _c(
              "router-link",
              {
                staticClass: "link pl-2 text-center",
                attrs: { to: { name: "login" } },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("auth.alreadyJoined")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }